module.exports = __webpack_public_path__ + "media/agent_1_furufuru.1919d734.mp3";